(function () {

    "use strict";

    function userModelFactory() {

        function UserModel() {
            this.id = "";
            this.name = "";
            this.userName = "";
            this.email = "";
            this.language = "";
            this.photo = "";
            this.isEnabled = false;
            this.groups = "";
            this.havePersonalBox = true;
            this.department = "";
            this.position = "";
            this.userType = 0;
            this.isAdministrator = false;
            this.isADImported = false;
            this.rol = "";
        }

        UserModel.prototype.deserialize = function (data) {
            this.id = data.id;
            this.name = data.name;
            this.language = data.language;
            this.userName = data.userName;
            this.email = data.email;
            this.photo = data.photo;
            this.isEnabled = data.isEnabled;
            this.groups = data.groups;
            this.havePersonalBox = data.havePersonalBox;
            this.department = data.department;
            this.position = data.position;
            this.userType = data.userType;
            this.isAdministrator = data.isAdministrator;
            this.isADImported = data.isADImported;
            this.rol = data.rol;
            return this;
        };

        return UserModel;
    }

    userModelFactory.$inject = [];

    angular.module("sphForms.auth")
        .factory("sphForms.modelUser", userModelFactory);
}());
